/* this file is transformed by vux-loader */
/* eslint-disable */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import MallPopup from './MallPopup';
import AddressDesc from './AddressDesc';
import TransferDom from "vux/src/directives/transfer-dom/index.js";
import Checker from "vux/src/components/checker/checker.vue";
import CheckerItem from "vux/src/components/checker/checker-item.vue";
import { OrderEdit } from '@/api/mall';
export default {
  components: {
    TransferDom: TransferDom,
    MallPopup: MallPopup,
    AddressDesc: AddressDesc,
    Checker: Checker,
    CheckerItem: CheckerItem
  },
  directives: {
    TransferDom: TransferDom
  },
  props: {
    active: {
      type: Boolean,
      "default": false
    },
    orderNo: String,
    orderObj: Object
  },
  data: function data() {
    return {
      show: this.active,
      text: ''
    };
  },
  watch: {
    active: function active(newVal) {
      this.show = newVal;
    },
    show: function show(val) {
      this.$emit('setShow', val);

      if (val) {
        this.$bus.$emit('unique-show', this);
      }
    }
  },
  computed: {},
  created: function created() {
    var _this = this;

    this.$bus.$on('unique-show', function (target) {
      if (target !== _this) {
        _this.show = false;
      }
    });
  },
  mounted: function mounted() {},
  methods: {
    refundConfirm: function refundConfirm() {
      var _this2 = this;

      console.log('点击退款确定按钮：  ' + this.text);
      var refundReason = this.text;

      if (!refundReason && refundReason.length <= 0) {
        Public.tips({
          text: '请填写退款原因'
        });
        return;
      }

      var params = {
        status: 7,
        orderNo: this.orderNo,
        refundReason: refundReason
      };
      var price = 0;

      if (this.orderObj) {
        price = this.orderObj.realPrice - this.orderObj.freight;
        params.refundPrice = price;
      }

      OrderEdit(params).then(function (data) {
        _this2.$emit('refundConfirm', _this2.text, _this2.orderNo, data);
      });
    },
    blurEvent: function blurEvent(val) {
      this.$emit('blur', val);
    }
  }
};